<template>
    <div class='tableList'>
            <div class='searchBox'>
                <input type="text" v-model.trim="searchIpt" class='searchIpt' placeholder="请输入项目名称"/>
                <button type='button' class='searchBtn' @click='searchData' clstag="pageclick|keycount|Pcpaimai_tender|search">搜索</button>
            </div>
            <div>
                <el-table
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column
                        label="所在地区"
                        width="200">
                        <template slot-scope="scope">
                            {{scope.row.provinceName}}-{{scope.row.cityName}}
                        </template>
                    </el-table-column>
                <el-table-column
                        label="项目名称"
                        min-width="200"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <router-link v-if='type==1' clstag="pageclick|keycount|Pcpaimai_tender|notice" :to="{path:'/ggView',query:{id:scope.row.id,tenderId:scope.row.tenderId,Pid:1}}" class='tdLink'>{{scope.row.tenderName}}</router-link>
                            <router-link v-if='type==2' clstag="pageclick|keycount|Pcpaimai_tender|notice" :to="{path:'/ggView',query:{id:scope.row.id,tenderId:scope.row.tenderId,Pid:2}}" class='tdLink'>{{scope.row.tenderName}}</router-link>
                            <router-link v-if='type==3' clstag="pageclick|keycount|Pcpaimai_tender|notice" :to="{path:'/ggView',query:{id:scope.row.id,tenderId:scope.row.tenderId,Pid:3}}" class='tdLink'>{{scope.row.tenderName}}</router-link>
                            <router-link v-if='type==5' clstag="pageclick|keycount|Pcpaimai_tender|notice" :to="{path:'/ggView',query:{id:scope.row.id,tenderId:scope.row.tenderId,Pid:5}}" class='tdLink'>{{scope.row.tenderName}}</router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="publishTime"
                        label="项目发布时间"
                        width="150"
                        :formatter="timeFormatter"
                        >
                    </el-table-column>
                    <el-table-column
                        label="报名时间"
                        width="150"
                        v-if="type==1||type==2"
                        >
                        <template slot-scope="scope">
                            <span v-if='timeFormatterEnd(scope.row)!=0' v-html='timeFormatterEnd(scope.row)'></span>
                            <span class='red' v-else>报名已结束</span>
                        </template> 
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page='currentPage'
                    @current-change='currentChange'
                    >
                </el-pagination>
            </div>
    </div>
</template>
<script>
export default {
    name:'zhaoBioaList',
    data(){
        return{
            tableData:[],
            total:0,
            pageSize:10,
            currentPage:1,
            searchIpt:'',
            type:1,//默认招标公告
        }
    },
    watch:{
        '$route'(){
            this.type = this.$route.params.id;
            this.currentPage=1;
            this.searchIpt='';
            this.getData();
        }
    },
    methods:{
        getData(){
            var lx
            if(this.type==2){
                lx='2,4'
            }else{
                lx=this.type
            }
            let para={
                page:this.currentPage,
                size:this.pageSize,
                type:this.type,
                types:lx,
                keyword:this.searchIpt
            } 
            this.$api.ggList(para).then(res=>{
                if(res.data.code==0){
                    this.tableData=res.data.data.pageData;
                    this.total=res.data.data.totalCount
                }else{
                    this.$message.error(res.data.message)
                }
            }).catch(()=>{
                
            }); 
        },
        //搜索
        searchData(){
            this.currentPage=1;
            this.getData()
        },
        currentChange(val){
            this.currentPage=val;
            this.getData();
        },
        //格式化时间
        timeFormatter(row){
            let time = row.publishTime;
            if(time){
                time = new Date(time);
                let y = time.getFullYear();
                let mon = (time.getMonth()+1)<10?'0'+(time.getMonth()+1):time.getMonth()+1;
                let d = time.getDate()<10?('0'+time.getDate()):time.getDate();
                return y +'-'+ mon +'-'+ d;
            }
            return ''
        },
        //格式化剩余天数
        timeFormatterEnd(row){
            let endTime = row.endTime;
            let nowTime=new Date().getTime();
            let cha=parseInt((endTime-nowTime)/ 1000 / 60 / 60 /24);
            if(cha>0){
                return  "仅剩<span class='red day' >"+cha+"</span>天"
            }else{
                if(parseInt((endTime-nowTime)/ 1000 / 60 / 60)>0){
                    return "仅剩<span class='red day' >"+parseInt((endTime-nowTime)/ 1000 / 60 / 60)+"</span>小时"
                }else{
                    if(parseInt((endTime-nowTime)/ 1000 / 60)>0){
                        return "仅剩<span class='red day' >"+parseInt((endTime-nowTime)/ 1000 / 60)+"</span>分钟"
                    }else{
                        return 0
                    }
                }
               
            }
            
        }
    },
    mounted(){
            function IEVersion() {
        var userAgent = navigator.userAgent;            //判断是否IE浏览器            
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;    
        if (isIE){ 
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");               
                reIE.test(userAgent);                
            var fIEVersion = parseFloat(RegExp["$1"]);                
                if (fIEVersion < 10 ) {                    
                        return true; 
                } else {
                    return false;   
                }
        }  
         }
        if (IEVersion()) {
            alert('当前浏览器版本过低，请升级到IE10及以上版本！') 
        }else{
            //从路由地址获取请求的是什么公告类型
                this.type=this.$route.params.id
                this.getData();
        }
    },
}
</script>